import React from 'react';
import {DistributionProduct, AvailableSerial} from '../models/distribution.model';
import {Hash} from 'lucide-react';
import {SimpleSerialSearch} from './SimpleSerialSearch';
import {UnifiedSerialNumberInput} from '../../serialNumbers';

interface SerialSelectionSectionsProps {
  selectedProduct: DistributionProduct | undefined;
  availableSerials: AvailableSerial[];
  selectedSerials: string[];
  bulkSerials: string[];
  isLoading: boolean;
  onSerialToggle: (serialNumber: string) => void;
  onBulkSerialsChange: (serials: string[]) => void;
  onSelectAll: () => void;
  onClearSelection: () => void;
}

const SerialSelectionSections: React.FC<SerialSelectionSectionsProps> = ({
  selectedProduct,
  availableSerials,
  selectedSerials,
  bulkSerials,
  isLoading,
  onSerialToggle,
  onBulkSerialsChange,
  onSelectAll,
  onClearSelection
}) => {
  if (!selectedProduct?.hasSerial) {
    return null;
  }

  return (
    <div className="space-y-6">
      {/* Section 1: Select from Available Serials */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Hash className="h-4 w-4" />
          اختيار من السيريلات المتاحة في المخزون ({selectedSerials.length} محدد)
        </label>
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
          <SimpleSerialSearch
            serials={availableSerials}
            selectedSerials={selectedSerials}
            onSerialToggle={onSerialToggle}
            onSelectAll={onSelectAll}
            onClearSelection={onClearSelection}
            isLoading={isLoading}
          />
        </div>
      </div>

      {/* Divider */}
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-white text-gray-500">أو</span>
        </div>
      </div>

      {/* Section 2: Add New Serials */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Hash className="h-4 w-4" />
          إدخال سيريلات جديدة للتسليم ({bulkSerials.filter(s => s.trim()).length} محدد)
        </label>
        <div className="bg-brand-50 border border-brand-200 rounded-lg p-4">
          <UnifiedSerialNumberInput
            value={bulkSerials}
            onChange={onBulkSerialsChange}
            context="distribution"
            required={true}
            placeholder="أدخل الرقم التسلسلي للتسليم"
            label=""
          />
        </div>
      </div>
    </div>
  );
};

export default SerialSelectionSections;
